import * as angular from 'angular';
import * as _ from 'underscore';
import { DesignRequest } from '../../../core';
import { IModalServiceInstance } from 'angular-ui-bootstrap';
import { DesignRequestService } from '../../services/designRequest.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { AccountService } from '../../../account/account.service';

class DesignRequestModalInstanceController {
    static $inject = ['$timeout', 'FileUploader', 'designRequestService', 'popupService', 'notificationService', 'definitionsService', 'accountService', '$translate'];
    uploader: any = null;
    model: DesignRequest = null;
    sessionID: number = null;
    waiting = false;
    needHelpForm: ng.IFormController;

    private result = false;
    private modalInstance: IModalServiceInstance = <any>this;
    private maxQueueSize = 10;
    private maxFileSizeMb = 50;
    private queueSizeFilterName = 'queueSizeFilter';
    private fileSizeFilterName = 'fileSizeFilter';
    private uploaderFilterErrors = {
        fileSize: [],
        queueSize: [],
        clear: () => {
            let i = this.uploaderFilterErrors;
            i.fileSize = [];
            i.queueSize = [];
        }
    };
    private fileThumbs = {};
    constructor(
        private $timeout: ng.ITimeoutService,
        private FileUploader: any,
        private designRequestService: DesignRequestService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private definitionsService: DefinitionsService,
        private accountService: AccountService,
        private $translate: angular.translate.ITranslateService
    ) {

        this.model = {
            Name: `${accountService.userData.firstName} ${accountService.userData.lastName}`,
            Phone: accountService.userData.phoneNumber.PhoneNumber,
            Email: accountService.userData.email,
            Description: null,
            AttachedFilesID: null
        };

        this.getSessionID();
        this.initUploader();
        this.initFileThumbs();
    }

    ok() {
        if (this.isValidForm()) {
            this.submit();
        }
    }

    cancel() {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }

    openMultipleInputup() {
        var el = $(angular.element('#multipleInputup'));
        this.$timeout(function () { el.click(); });
    }

    getFileThumb = (fileItem: any) => {
        let name = fileItem.file && fileItem.file.name ? fileItem.file.name : '';
        name = name.substr(name.lastIndexOf('.') + 1);
        let classThumb = this.fileThumbs[name];
        return _.isUndefined(classThumb) ? 'fa fa-file-o' : classThumb;
    }

    $onDestroy = async () => {
        if (!this.result) {
            this.designRequestService.deleteFiles(this.sessionID);
        }
    }

    private async submit() {
        this.waiting = true;
        this.attachedFilesID();
        try {
            await this.designRequestService.needHelp(this.sessionID, this.model);
            this.result = true;

            this.notificationService.showSuccessMessage(
                {
                    title: this.$translate.instant('design_request_thank_you'),
                    body: this.$translate.instant('design_request_sent')
                });
            this.$timeout(() => { this.modalInstance.close({ $value: this.result }); }, 500);

        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private attachedFilesID() {
        this.model.AttachedFilesID = _.filter(_.pluck(this.uploader.queue, 'serverSideID')
            , function (id: any) { return _.isNumber(id); });
    }

    private isValidForm(): boolean {
        this.model.Name = this.model.Name ? this.model.Name.trim() : '';
        this.model.Phone = this.model.Phone ? this.model.Phone.trim() : '';
        this.model.Email = this.model.Email ? this.model.Email.trim() : '';
        this.model.Description = this.model.Description ? this.model.Description.trim() : '';
        // name
        this.needHelpForm.name.$setValidity('required', this.model.Name.length > 0);
        if (!this.needHelpForm.name.$error.required) {
            this.needHelpForm.name.$setValidity('length', this.model.Name.length >= 3 && this.model.Name.length <= 40);
        } else {
            this.needHelpForm.name.$setValidity('length', true);
        }
        // phone
        this.needHelpForm.phone.$setValidity('required', this.model.Phone.length > 0);
        if (!this.needHelpForm.phone.$error.required) {
            this.needHelpForm.phone.$setValidity('length', this.model.Phone.length >= 6 && this.model.Phone.length <= 20);
        } else {
            this.needHelpForm.phone.$setValidity('length', true);
        }
        // email
        this.needHelpForm.email.$setValidity('required', this.model.Email.length > 0);
        if (!this.needHelpForm.email.$error.required) {
            this.needHelpForm.email.$setValidity('email', this.definitionsService.regexEmail.test(this.model.Email));
        } else {
            this.needHelpForm.email.$setValidity('email', true);
        }
        // description
        this.needHelpForm.description.$setValidity('required', this.model.Description.length > 0);

        return this.needHelpForm.$valid;
    }

    private async getSessionID() {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            this.sessionID = await this.designRequestService.getSessionID();
            this.uploader.url = this.designRequestService.getUploaderUrl(this.sessionID);
            this.waiting = false;
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
        this.needHelpForm.$setPristine();
    }

    private initUploader() {
        let i = this;
        this.uploader = new this.FileUploader({
            headers: this.designRequestService.getAuthorizationBearer(),
            autoUpload: true
        });
        // filters
        this.uploader.filters.push({
            name: this.queueSizeFilterName,
            fn: function (item: any /* {File|FileLikeObject} */, options: any) {
                return this.queue.length < i.maxQueueSize;
            }
        });
        this.uploader.filters.push({
            name: this.fileSizeFilterName,
            fn: function (item: any /* {File|FileLikeObject} */, options: any) {
                return item.size / 1024 / 1024 < i.maxFileSizeMb;
            }
        });
        // events
        this.uploader.onSuccessItem = (fileItem: any, id: number | string, status: any, headers: any) => {
            fileItem.serverSideID = id;
            fileItem.errorMessage = null;
        };

        this.uploader.onProgressAll = (progress: number) => {
            this.waiting = progress !== 100;
        };

        this.uploader.onErrorItem = function (fileItem: any, response: any, status: number, headers: any) {
            if (_.isNumber(status) && status > 0) {
                fileItem.errorMessage = 'Upload failed';
            } else {
                fileItem.errorMessage = 'Upload failed';
            }
        };

        this.uploader.onAfterAddingAll = async (addedItems: any[]) => {
            this.uploader.queue = _.filter(this.uploader.queue, function (item: any) {
                return !item.excludeFromQueue;
            });
            this.waiting = true;
            try {
                if (this.uploaderFilterErrors.fileSize.length > 0) {


                    let listFile = '<div class="mb10">';
                    _.forEach(this.uploaderFilterErrors.fileSize, function (name: string) {
                        listFile += '<div>' + name + '</div>';
                    });
                    listFile += '</div>';
                    let aDropbox = '<a href="https://www.dropbox.com/home"  target="_blank">Dropbox</a>';
                    let aGoogleDrive = '<a href="https://drive.google.com/drive/my-drive"  target="_blank">Google Drive</a>';

                    let popupTitle = this.$translate.instant('max_file_size_is', { maxFileSizeMb: this.maxFileSizeMb });
                    let popupContent = `<div>${this.$translate.instant('following_files_are_too_large', { maxFileSizeMb: this.maxFileSizeMb })}</div>${listFile}<div>${this.$translate.instant('please_use_storage_services', { dropbox: aDropbox, googleDrive: aGoogleDrive })}</div>`;

                    await this.popupService.alert({
                        classPopup: 'width308',
                        title: popupTitle,
                        content: popupContent
                    });

                } else if (this.uploaderFilterErrors.queueSize.length > 0) {
                    let popupTitle = this.$translate.instant('too_many_files');
                    let popupContent = this.$translate.instant('too_many_files_details', { maxQueueSize: this.maxQueueSize })
                        || `<p>You can attach up to ${this.maxQueueSize} files to this request.</p>`;
                    await this.popupService.alert({
                        classPopup: 'width308',
                        title: popupTitle,
                        content: popupContent
                    });
                }

            } catch (error) {
                this.waiting = false;
            }

            this.waiting = false;
            this.uploaderFilterErrors.clear();
        };

        this.uploader.onWhenAddingFileFailed = (file: any /* {File|FileLikeObject} */, filter: any, options: any) => {
            file.excludeFromQueue = true;
            if (filter.name === this.queueSizeFilterName) {
                this.uploaderFilterErrors.queueSize.push(file.name);
                this.uploader.queue.push(file);
            } else if (filter.name === this.fileSizeFilterName) {
                this.uploaderFilterErrors.fileSize.push(file.name);
                this.uploader.queue.push(file);
            }
        };
    }

    private setFileThumbs(filesExtension: string, classExtension: string) {
        _.forEach(filesExtension.split(','), (extension) => {
            this.fileThumbs[extension.trim()] = classExtension;
        });
    }
    private initFileThumbs() {
        let archive = 'zip, rar, 7z, cab, gz, tar';
        this.setFileThumbs(archive, 'fa fa-file-archive-o');

        let img = 'ai, eps, psd, psb, jpg, jpeg, gif, png, cdr, svg, bmp, raw, cr2, nef, tga, tif, tiff, wmf';
        this.setFileThumbs(img, 'fa fa-file-image-o');

        let excel = 'xls, xlsx';
        this.setFileThumbs(excel, 'fa fa-file-excel-o');

        let word = 'doc, docx, rtf';
        this.setFileThumbs(word, 'fa fa-file-word-o');

        let powerpoint = 'ppt, pptx';
        this.setFileThumbs(powerpoint, 'fa fa-file-powerpoint-o');

        let text = 'txt, htm, html';
        this.setFileThumbs(text, 'fa fa-file-text-o');

        let pdf = 'pdf';
        this.setFileThumbs(pdf, 'fa fa-file-pdf-o');
    }

}

angular.module('naut').component('designRequest', {
    template: require('./designRequest.html'),
    controller: DesignRequestModalInstanceController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/components/designRequest/designRequest.component.ts